export class Constants {
	public navLinkItems = {
		user: {
			person: { displayName: 'JOHN SMITH', icon: 'account_circle' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
		documentControl: {
			displayName: 'Document Control', url: 'document-control/load-route'
		},
		unload: {
			displayName: 'Unload', url: 'unload'
		},
		reload: {
			displayName: 'Reload', url: 'reload'
		},
		boxLevel: {
			documentControl: { displayName: 'Document Control', url: 'box-level/document-control' },
			unload: { displayName: 'Unload', url: 'box-level/unload' },
			reload: { displayName: 'Reload', url: 'box-level/reload' }
		},
		returnables: {
			returnsunload: { displayName: 'Returns-Unload', url: 'returnables/returnsunload' },
			returnsreload: { displayName: 'Returns-Reload', url: 'returnables/returnsreload' },
			returnRouteSummary: { displayName: 'Return Route Summary', url: 'returnables/returnroutesummary' },
			returnsHistory: { displayName: 'Returns-History', url: 'returnables/returnshistory' },
			returnsPCB: { displayName: 'Returns PCB', url: 'returnables/returns-pcb' }

		},
		// exportParts: {
		// 	routeExportParts: {displayName: 'PDF GENERATION - MODULE ID', url: '/pdf-generation-module-id'}
		// },
		reports: {
			routeSummary: { displayName: 'Route Summary', url: 'reports/route-summary' },
			laneInquiry: { displayName: 'Lane Inquiry', url: 'reports/lane-inquiry' },
			pdfReports: { displayName: 'PDF Reports', url: 'reports/pdf-reports' },
			TSCSDataSummary: { displayName: 'TSCS Data Summary', url: 'reports/tscs-data-summary' },
			orderSummary: { displayName: 'Order Discrepancy Summary', url: 'reports/order-summary' },
			fvmdatadownload: { displayName: 'FVM Data Download', url: 'reports/fvm-data-download' },
			routePCB: { displayName: 'Route PCB', url: 'reports/route-pcb' },
			laneSummary: { displayName: 'Lane Summary', url: 'reports/lane-summary' },
			laneDataDownload: { displayName: 'Lane Data Download', url: 'reports/lane-data-download' }

		},
		administration: {
			siteConfiguration: { displayName: 'Site Configuration', url: 'administration/site-configuration' },
			userManagement: { displayName: 'User Management', url: 'administration/user-management' },
			cLoadManagement: { displayName: 'C-Load Management', url: 'administration/cloadmanagement' },
			connectionManagement: { displayName: 'Connection Management', url: 'administration/connection-management' },
			workDayManagement: { displayName: 'Workday Management', url: 'administration/workdaymanagement' },
			dockManagement: { displayName: 'Dock Management', url: 'administration/dockmanagement' },
			shopManagement: { displayName: 'Shop Management', url: 'administration/shopmanagement' },
			complianceManagement: { displayName: 'Compliance Management', url: 'administration/complaince-management' },
			complianceReview: { displayName: 'Compliance Review', url: 'administration/complaince-review' },
			dockDoorManagement: { displayName: 'Dock Door Management', url: 'administration/dockdoormanagement' },
			systemManagement: { displayName: 'System Management', url: 'administration/systemmanagement' },
			ppcbconfig: { displayName: 'Parts PCB Configuration', url: 'administration/ppcbconfiguration' },
			rpcbconfig: { displayName: 'Returns PCB Configuration', url: 'administration/rpcbconfiguration' }
		},
		exportParts: {
			createContainer: { displayName: 'Create Container', url: 'export-parts/create-container' },
			containerConsolidation: { displayName: 'Container Consolidation', url: 'export-parts/container-consolidation' },
			pdfGenerationModuleId: { displayName: 'Module PDF', url: 'export-parts/pdf-generation-module-id' },
			pdfGenerationContainerId: { displayName: 'Container PDF', url: 'export-parts/pdf-generation-container-id' },
			uploadDocInfo: { displayName: 'Manage Booking Information', url: 'export-parts/uploaddocinfo' },
			exportLoadType: { displayName: 'Manage Load Types', url: 'export-parts/export-load-type' },
		},
		history: {
			displayName: 'History', url: 'history'
		}
	}

	public gridRowHeight = 30;
	public LoaderComponent = "loader-component";
	public LoaderInitializer = "loader-initializer";
	public notificationMessageTimeShort = 6000;
	public FileValidation = "Validation failed, Please find error details below.";
	public APIErrorMessage = "Something went wrong, Please Contact System Administrator.";
	public APIDataSaved = "Data saved successfully.";
	public APIDataUpdated = "Data updated successfully.";
	public APIDataDeleted = "Data deleted successfully.";
	public APIDataReopened = "Container reopened successfully.";
	public Lanesucces = "Create lane(s) successful";
	public printNorow = 'No lanes selected to print.'
	public HistoryNoDataToExport = "History must be loaded to export."
	public BoxLevelNoDataToExport = "An Order must be loaded to export."
	public BoxLevelHistorySelectNode = "Please select one row for history."
	public BoxLevelInquirySelectNode = "Please select at least one row for Inquiry."
	public RoutesFound = "Route found.";
	public NoRoutesFound = "Route not found.";
	public tooManyRoutes = 'Too many routes found.'
	public tscsconncError = 'TSCS Connection Error'
	public tscsnoLink = 'TSCS Link not available. Proceed?'
	public CutRoute = "Route found. Route was cut on following cut date."
	public ValidCheckbox = "You must select unload, reload or both for report."
	public ReportSummarysubmit = "You must select unload, reload or both for route summary report."
	public LimitDataToShow = "Only the first 500 results can be shown. Click export to retrieve a maximum of 25,000 rows."
	public NoDataToExport = "A route must be loaded to export.";
	public ExportData = "Exporting routes";
	public ExportRoute = "Exporting Return Route Summary for"
	public ExportLoad = "Exporting Continuous Load data";
	public ShopExport = "Exporting Shop data.";
	public ConnectionExport = "Exporting Connection data.";
	public SelectRowForHistory = "Please select one row for history.";
	public NoHistoryFound = "Search returned no results."
	public HistoryFound = "History Found."
	public ExportHistory = "Exporting History."
	public HistoryValidation = "Showing route history records.";
	public LoadHistory = "History must be loaded to export."
	public notificationMessageTime = 6000;
	public InputValidation = "Inputs are not available";
	public OrderNotFound = "Order not found";
	public OrderNotFound1 = "Orders not found";
	public HistoryNotFound = "History not found";
	public ExportingDiscrepancySummary = "Exporting Discrepancy Summary."
	public RouteDate = 'Route and Datetime combination exists in multiple locations. Do you want to proceed with Logged-in Location?'
	public userAuthFailed = 'User Authentication Failed'
	public invalidRole = "Invalid Role"
	public inactiveLog = 'User logged is InActive'
	public DockNotFound = "Dock not found"
	public DockValidation = "Site type validation failed"
	public NoDataInDateRange = "No Current Site Data found for Date Range"
	public MasterSetupError = "Cannot set site type to 'LaneControl' without one of each additional lane type created."
	public UpdateFailed = "Failed to Update"
	public WorkdayExport = "Exporting Workday data.";
	public NoDataToExportDock = "Dock must be loaded to export";
	public TSCSDataSummaryReportExport = "Exporting TSCS Data Summary Report.";
	public laneSummaryReportExport = "Exporting Lane Summary Report.";
	public laneDataDownloadReportExport = "Exporting Lane Data Download Report.";
	public ComplianceMessage = 'Compliance configuration was saved.'
	public DeleteMsg = "Delete successful."
	public LimitDataToShow1000 = "Route Found. Only the first 1000 results can be shown. Click export to retrieve all rows."
	public DataToShow1000 = "Only the first 1000 results can be shown. Click export to retrieve all rows."
	public routeRequired ='Route is required Or Route with % wild card required'
	public processedOtherSite = 'Cannot delete. Skid processed elsewhere.'
	public inquiryWarning ='Warning : Attempting to Delete Picked skids'
	public inquiryMaxMsg =`Can't select more than  50 rows for inquiry at a time`
	public noData ='No Data to Export'
	public ReturnHistoryType = [
		{ value: 'RTN_SET_TRAILER_NUMBER', name: 'Returns Set Trailer' },
		{ value: 'RTN_DELETE_TRAILER', name: 'Returns Delete Trailer' },
		{ value: 'RTN_CUT_ROUTE', name: 'Returns Cut Route' }
	]
	public shopMessage = 'Shop configuration was saved'
	public orderDiscExpMsg = 'Orders must be loaded to export'
	public defaultMaxRouteWeight = 20185;
	public defaultOrderWeight = 350;
	public UploadWorkdayLimit = 35;
	public UploadConnectionLimit = 25;
	public HistoryActionType = [
		{ value: 'ADD_NON_COMPLIANCE_ISSUE', name: 'Compliance Issue' },
		{ value: 'ADD_UNPLANNED_ORDER', name: 'Unplanned Order' },
		{ value: 'CHECKSHEET_ENTRY', name: 'Checksheet' },
		{ value: 'COMPLETE_SUBROUTE', name: 'Complete Subroute' },
		{ value: 'CONNECTION_EVENT', name: 'Connection Event' },
		{ value: 'CUT_MAINROUTE', name: 'Cut Route' },
		{ value: 'DELETE_NON_COMPLIANCE_ISSUE', name: 'Delete Comp. Issue' },
		{ value: 'DELETE_SKID', name: 'Delete Skid' },
		{ value: 'DENY_UNPLANNED_ORDER', name: 'Deny Unplanned Order' },
		{ value: 'OVERWEIGHT_EVENT', name: 'Overweight Event' },
		{ value: 'OVERWEIGHT_DENY_EVENT', name: 'Deny Overweight Event' },
		{ value: 'PLANNED_QTY_CHANGED', name: 'Plan Qty Change' },
		{ value: 'REOPEN_MAINROUTE', name: 'Reopen Route' },
		{ value: 'REPLACE_UNIQUE', name: 'Replace Unique' },
		{ value: 'REVERSE_COMPLETE_SUBROUTE', name: 'Reverse Complete Route' },
		{ value: 'REVERSE_UNPLANNED_ORDER', name: 'Reverse Unplanned' },
		{ value: 'SET_TRAILER_NUMBER', name: 'Set Trailer' },
		{ value: 'SKID_SCANNED', name: 'Skid Scan' },
		{ value: 'START_ROUTE', name: 'Start Route' },
		{ value: 'UNPICK_ORDER', name: 'Unpick Order' },
		{ value: 'UNPICK_SKID', name: 'Unpick Skid' },
		{ value: 'UPDATE_NON_COMPLIANCE_ISSUE', name: 'Modify NC Issue' },
		{ value: 'DELETE_SKID_WITH_REVERSE_UNPLANNED_ORDER', name: 'Reverse Unplanned' },
		{ value: 'UNPICK_SKID_WITH_REVERSE_UNPLANNED_ORDER', name: 'Reversed Unplanned' },
		{ value: 'HISTORY_ACTION_TYPE_BYPASS_ORDER', name: 'Bypass Order' },
		{ value: 'HISTORY_ACTION_TYPE_REVERSE_BYPASS_ORDER', name: 'Reverse Bypass' },
		{ value: 'WRONG_LANE_SCANNED', name: 'Putaway Wrong Lane Scan' },
		{ value: 'PUTAWAY_VERIFIED', name: 'Putaway Verified' },
		{ value: 'SKID_SCANNED_TO_LANE', name: 'Skid Scanned to Lane' },
		{ value: 'ROUTE_CLOSED_AT_LANE', name: 'Route Closed at Lane' },
		{ value: 'ROUTE_REOPENED_AT_LANE', name: 'Route Reopened at Lane' },
		{ value: 'SUBROUTE_RECONCILE_DENY', name: 'Subroute Reconcile Deny' },
		{ value: 'BOX_SCANNED', name: 'Box Scanned' },
		{ value: 'BOX_SKID_CLOSED', name: 'Box Skid Closed' },
		{ value: 'BOX_ORDER_CLOSED', name: 'Box Order Closed' },
		{ value: 'UNDO_BOX_SCANNED', name: 'Unpick Box' },
		{ value: 'BOX_UNPLANNED', name: 'Box Unplanned' },
		{ value: 'BOX_DOC_CONTROL', name: 'Box Document Control' },
		{ value: 'BOX_TRIAL_COMMENT', name: 'Box Trial Comment' },
		{ value: 'APPROVE_UNPLANNED', name: 'Approve Unplanned' },
		{ value: 'DENY_UNPLANNED', name: 'Deny Unplanned' },
		{ value: 'HIST_ERROR', name: 'Reload Errors' },
		{ value: 'WORKDAY_MANAGEMENT', name: 'Workday Mgmnt' },
		{ value: 'CONNECTION_MANAGEMENT', name: 'Connection Mgmnt' },
		{ value: 'SHOP_MANAGEMENT', name: 'Shop Management' },
		{ value: 'DOCK_MANAGEMENT', name: 'Dock Management' },
		{ value: 'DOCK_DOOR_MANAGEMENT', name: 'Dock Door Management' },
		{ value: 'ACCEPT_DUPLICATE_USL', name: 'Accept Duplicate USL' },
		{ value: 'TSCS_PLANNED_ORDER', name: 'TSCS Planned Order' },
		{ value: 'POSTED_TO_TSCS', name: 'Posted To TSCS' },
		{ value: 'FAILED_TO_POST_TSCS', name: 'Failed To Post TSCS' },
		{ value: 'EXPORT_RECEIVE_PARTS', name: 'Export Parts Receive' },
		{ value: 'WRONG_DESTINATION', name: 'Wrong Destination' },
		{ value: 'APPROVE_WRONG_DESTINATION', name: 'Appv Wrong Destination' },
		{ value: 'DENY_WRONG_DESTINATION', name: 'Deny Wrong Destination' },
		{ value: 'APPROVE_MIXED_STACK_SKID', name: 'Appv Mixed Stack Skid' },
		{ value: 'WRONG_MAIN_ROUTE', name: 'Wrong Main Route' },
		{ value: 'WRONG_MR_RUN', name: 'Wrong MR Run' },
		{ value: 'WRONG_MR_DATE', name: 'Wrong MR Run' },
		{ value: 'WRONG_MR_TIME', name: 'Wrong MR Run' },
		{ value: 'WRONG_SUPP_ROUTE', name: 'Question Supplement' },
		{ value: 'WRONG_EXP_DEST', name: 'Wrong Expedite Dest' },
		{ value: 'EXP_NSUPPLEMENT', name: 'Exp Named Suppl' },
		{ value: 'EXP_USUPPLEMENT', name: 'Exp Unnamed Suppl' },
		{ value: 'EXP_DOCK_INVALID', name: 'Exp Unusual Dock' },
		{ value: 'EXPEDITE_UNPLANNED', name: 'Expedite Unplanned' },
		{ value: 'NORMAL_UNPLANNED', name: 'Order Unplanned' },
		{ value: 'RECORDS_ADDED', name: 'Record Added' },
		{ value: 'RECORDS_UPDATED', name: 'Record Updated' },
		{ value: 'RECORDS_DELETED', name: 'Record Deleted' },
		{ value: 'RTN_SET_TRAILER_NUMBER', name: 'Returns Set Trailer' },
		{ value: 'RTN_DELETE_TRAILER', name: 'Returns Delete Trailer' },
		{ value: 'RTN_CUT_ROUTE', name: 'Returns Cut Route' },
		{ value: 'CONTINOUS_LOAD', name: 'Continuous Load' },
		{ value: 'MULTI_INVOICE', name: 'Multi Invoice' },




	]
	public home = {
		title: "Home",
		username: "User Name",
		userid: "USER ID",
		primarySiteName: " Primary Site",
		roles: "Roles",
		changesprimarysitelabel: "CHANGE PRIMARY SITE",
		changesiteButton: "CHANGE SITE"
	}
	public history = {
		title: "History",
		routehistorylabel: "Route History",
		orderhistorylabel: "Order History",
		ubchistorylabel: "UBC History",
		typehistorylabel: "Type History",
		trailernumberhistorylabel: "Trailer Number History",
		exportlabel: "EXPORT",
		routehistory: {
			routelabel: "Route",
			datelabel: "Date",
			searchbutton: "SEARCH",
			checkboxlabel: "Include Corresponding Route",
			resetlabel: "RESET"
		},
		orderhistory: {
			orderlabel: "Order",
			plantlabel: "Plant",
			supplierlabel: "Supplier",
			Docklabel: "Dock",
			searchbutton: "SEARCH",
			resetlabel: "RESET"
		},
		ubchistory: {
			uniqueserialabel: "Unique Serial",
			searchbutton: "SEARCH",
			resetlabel: "RESET"
		},
		typehistory: {
			actiontypelabel: "Select an action type",
			fromdatelabel: "From",
			todatelabel: "To",
			searchbutton: "SEARCH",
			resetlabel: "RESET"
		},
		trailernumberhistory: {
			trailernumber: "Trailer Number",
			fromdatelabel: "From",
			todatelabel: "To",
			searchbutton: "SEARCH",
			resetlabel: "RESET"

		}

	}
	public returnables = {
		returnroutesummary: {
			title: "Return Route Summary",
			datelabel: "Date",
			typelabel: "Type",
			firstcheckboxlabel: "Unload",
			secondcheckboxlabel: "Reload",
			buttonlabel: "LOAD ROUTES",
			resetlabel: "RESET",
			exportlabel: "EXPORT"
		},
		returnsunload: {
			title: "Returns-Unload",
			label: "Route",
			datelabel: "Unload Date",
			buttonlabel: "LOAD ROUTE",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			unverifiedlabel: "Un-Verified",
			verifiedlabel: "Verified"
		},
		returnsreload: {
			title: "Returns-Reload",
			datelabel: "Reload Date",
			buttonlabel: "LOAD ROUTE",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			unverifiedtab: "Un-Verified",
			verifiedtab: "Verified"
		},
		returnshistory: {
			title: "Returns-History",

			resetlabel: "RESET",
			exportlabel: "EXPORT",
			routehistlabel: "Route History",
			typehistlabel: "Type History",
			trailernumhistlabel: "Trailer Number History",
			routehistory: {
				routelabel: "Route",
				datelabel: "Date",
				searchbutton: "SEARCH",
				resetlabel: "RESET"
			},
			typehistory: {
				actiontypelabel: "Select an action type",
				fromdatelabel: "From",
				todatelabel: "To",
				searchbutton: "SEARCH",
				resetlabel: "RESET"
			},
			trailernumberhistory: {
				trailernumber: "Trailer Number",
				fromdatelabel: "From",
				todatelabel: "To",
				searchbutton: "SEARCH",
				resetlabel: "RESET"

			}
		}
	}
	public documentcontrol = {
		title: "Document control",
		label1: "Route",
		datelabel: "Unload Date",
		label2: "Skid/Route Quantity",
		label3: "Driver CheckSheet",
		buttonlabel: "LOAD ROUTE",
		resetlabel: "RESET",
		exportlabel: "EXPORT",
		unverifiedtab: "Un-Verified",
		verifiedtab: "Verified",
		historybutton: "HISTORY",
		inquirybutton: "INQUIRY"
	}
	public reload = {
		title: "Reload",
		label1: "Route",
		datelabel: "Reload Date",
		label2: "Trailer#",
		label4: "ROUTE KG: ",
		button1label: "LOAD ROUTE",
		button2label: "REOPEN M/R",
		button3label: "RESEND TSCS",
		button4label: "CUT M/R",
		resetlabel: "RESET",
		exportlabel: "EXPORT",
		unverifiedtab: "Un-Verified",
		verifiedtab: "Verified",
		bypassedtab: "Bypassed",
		trailertab: "Trailer",
		historybutton: "hISTORY",
		inquirybutton: "INQUIRY"
	}
	public unload = {
		title: "Unload",
		label1: "Route",
		datelabel: "Unload Date",
		label2: "Trailer#",
		buttonlabel: "LOAD ROUTE",
		resetlabel: "RESET",
		exportlabel: "EXPORT",
		unverifiedtab: "Un-Verified",
		verifiedtab: "Verified",
		trailertab: "Trailer",
		historybutton: "hISTORY",
		inquirybutton: "INQUIRY"

	}
	public boxlevel = {
		documentcontrol: {
			title: "Box Level-Document Control",
			label1: "Order",
			label2: "Supplier",
			label3: "PlantDock",
			label4: "Driver Checksheet",
			buttonlabel: "LOAD ORDERS",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			boxhistorylabel: "BOX EXPORT HISTORY",
			unscannedtab: "Un-Scanned",
			scannedtab: "Scanned",
			historybutton: "HISTORY",
			inquirybutton: "INQUIRY"
		},
		unload: {
			title: "Box Level-Unload",
			label1: "Order",
			label2: "Supplier",
			label3: "PlantDock",
			buttonlabel: "LOAD ORDERS",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			boxhistorylabel: "BOX EXPORT HISTORY",
			unverifiedtab: "Un-Verified",
			verifiedtab: "Verified",
			trailertab: "Trailer",
			historybutton: "hISTORY",
			inquirybutton: "INQUIRY"

		},
		reload: {
			title: "Box Level-Reload",
			label1: "Order",
			label2: "Supplier",
			label3: "PlantDock",
			label4: "Trailer#",
			buttonlabel: "LOAD ORDERS",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			boxhistorylabel: "BOX EXPORT HISTORY",
			unverifiedtab: "Un-Verified",
			verifiedtab: "Verified",
			trailertab: "Trailer",
			historybutton: "hISTORY",
			inquirybutton: "INQUIRY"

		}


	}
	public reports = {
		routesummary: {
			title: "Route Summary",
			datelabel: "Date",
			typelabel: "Type",
			checkbox1label: "Unload",
			checkbox2label: "Reload",
			buttonlabel: "LOAD ROUTES",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			historybutton: "HISTORY"

		},
		laneinquiry: {
			title: "Lane Inquiry",
			mattab1label: "WL/BC",
			mattab2label: "Lane Search",
			mattab3label: "UBC Search",
			exportbutton: "EXPORT",
			laneinquiryresult: {
				label1: "putawayLaneId",
				buttonlabel: "Search",
				label2: "Unique Serial"
			}
		},
		tscsdatasummry: {
			title: "TSCS Data Summary",
			mattab1label: "Route Search",
			mattab2label: "Date Search",
			routesearch: {
				label: "Route",
				datelabel: "Date",
				resetlabel: "RESET",
				buttonlabel: "SEARCH",
			},
			datesearch: {
				fromdatelabel: "From",
				todatelabel: "To",
				buttonlabel: "SEARCH",
				resetlabel: "RESET"
			}

		},
		ordersummary: {
			title: "Order Discrepancy Summary",
			label1: "Date",
			timelabel: "Start Time",
			timelabel2: "End Time",
			buttonlabel: "LOAD ORDERS",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
			checkbox1label: "Qty Issue",
			checkbox2label: "Missing",
			checkbox3label: "Late",
			checkbox4label: "Unplanned",
			checkbox5label: "Plan Issue",
			historybutton: "HISTORY"
		},
		fvmdatadowmload: {
			title: "FVM Data Download",
			datelabel1: "From",
			datelabel2: "To",
			label1: "NAMC",
			label2: "CD/SC",
			buttonlabel: "LOAD ROUTE",
			resetlabel: "RESET",
			exportlabel: "EXPORT",
		},
	}
	administration = {
		cloadmanagement: {
			title: "C-Load Management",
			exportlabel: "EXPORT"
		},
		siteconfiguration: {
			title: "Site Configuration",
			mattab1label: "Master Setup",
			masttab2label: "Route System",
			mastertab3label: "Additonal Lanes",
			mastertab4label: "Wait Lane",
			mastersetup: {
				label1: "Site Type",
				sitetypedropdownoption1: "Standard",
				sitetypeDropDownoption2: "LaneControl",
				sitetypedropdownoption3: "Mixed",
				label2: "Maximum Trailer Weight",
				label3: "Discrepancy U/L Minutes",
				label4: "Discrepancy R/L Minutes",
				label5: "Reload Sound",
				reloadsounddropdwnoption1: "On",
				reloadsounddropdwnoption2: "Off",
				label6: "Reload Scan Type",
				reloadscantypedropdwnoption1: "Sync",
				reloadscantypedropdwnoption2: "Async",
				label7: "Unload Sound",
				unloadsounddropdwnoption1: "On",
				unloadsounddropdwnoption2: "Off",
				label8: "Unload Scan Type",
				unloadscantypedropdwnoption1: "Sync",
				unloadscantypedropdwnoption2: "Async",
				label9: "Waitlane Pull Buffer",
				note: "Note: Master setup save button appears only if you have the 'Master Setup' role.",
				buttonlabel: "SAVE"
			},
			routesystem: {
				button1: "DELETE",
				button2: "ADD"
			},
			additionallane: {
				button1: "DELETE",
				button: "ADD"
			},
			waitlane: {
				button1: "DELETE",
				button2: "ADD"
			}
		},
		shopmanagement: {
			title: "Shop Management",
			button1: "DELETE",
			button2: "ADD"
		},
		systemmanagement: {
			title: "System Management"
		},
		usermanagement: {
			title: "User Management",
			label1: "User ID/Email",
			button1: "SERACH",
			button2: "ADD USER",
			resetlabel: "RESET",

		},
		compliancemanagement: {
			title: "Compliance Management",
			exportlabel: "EXPORT",
			button1: "SAVE",
			button2: "DELETE",
			button3: "ADD"
		},
		compliancereview: {
			title: "Compliance Review",

		}
	}





	// constructor() {}
}